import get from 'lodash/get';

export default function getCurrencyFromQuery(urlQuery) {
  let selectedCurrency = get(urlQuery, 'query.priceCurrency');
  let query = get(this, 'props.location.query.query');
  if (query) {
    query = JSON.parse(query);
    if (query.priceCurrency) {
      selectedCurrency = query.priceCurrency;
    }
  }
  return selectedCurrency;
}
